import Cookies from 'js-cookie'
import CryptoJS from 'crypto-js'
import store from 'store'
import { fabric } from 'fabric'

import { options } from '@conf'

import axios from '@utils'

export function encrypt(str) {
  let key = CryptoJS.enc.Base64.parse(options.key) // key 要和后台一致
  let iv = CryptoJS.enc.Base64.parse(options.iv) // iv 要和后台一致
  str = CryptoJS.enc.Utf8.parse(str)
  return CryptoJS.DES.encrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC
  }).toString()
}
// 登录密码解密
export const decrypt = str => {
  let key = CryptoJS.enc.Base64.parse(options.key)
  let iv = CryptoJS.enc.Base64.parse(options.iv)
  let decryptObj = CryptoJS.DES.decrypt(str, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC
  })
  return decryptObj.toString(CryptoJS.enc.Utf8)
}

const defaultCookies = Cookies.withAttributes({
  path: '/',
  domain: process.env.VUE_APP_Domain
})

export const setCookie = (str, data, obj) => {
  defaultCookies.set(str, data, { expires: 300, ...obj })
}
export const getCookie = str => {
  return defaultCookies.get(str)
}
export const setStore = (str, data) => {
  store.set(str, data)
}
export const getStore = str => {
  return store.get(str)
}
export const testData = data => {
  let reg = /(^\s+)|(\s+$)|\s+/g
  return reg.test(data)
}

export const testIpt = data => {
  let reg = /([^\s])/g
  return reg.test(data)
}

// 时间格式化
export function DateFormat(date, format) {
  // time时间格式化
  if (date === null || date === '') return ''

  if (typeof date === 'string') {
    // 如果是字符串转换为日期型
    date = new Date(date)
  }

  if (!format) {
    format = 'yyyy-MM-dd HH:mm:ss'
  }
  let obj = {
    'M+': date.getMonth() + 1, // 返回实际月份
    'd+': date.getDate(), // 返回当月第几天
    'H+': date.getHours(), // 返回小时
    'm+': date.getMinutes(), // 返回分钟
    's+': date.getSeconds(), // 返回秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 返回第几个季度
    S: date.getMilliseconds(), // 返回毫秒
    w: date.getDay(), // 返回星期几，0为星期日
    W: '日一二三四五六'.charAt(date.getDay()) // 返回星期几的中文表示
  }

  // 年的单独处理
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  // 其他格式处理

  for (let k in obj) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length === 1
          ? obj[k]
          : ('00' + obj[k]).substr(('' + obj[k]).length)
      )
    }
  }
  return format
}

//  遍历执行方法
export const forEach = (obj, fn) => {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return
  }
  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj]
  }
  if (Array.isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj)
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj)
      }
    }
  }
}

// MathQueue
export const MathQueue = function(elementId) {
  if (!window.MathJax) {
    return
  }
  window.MathJax.Hub.Queue([
    'Typeset',
    window.MathJax.Hub,
    document.getElementById(elementId)
  ])
}
// 合成图片
// eslint-disable-next-line space-before-function-paren
export const creatImge = async (imageUrl, dataArr = []) => {
  if (!document.createElement('canvas').getContext) {
    throw new Error('浏览器不支持canvas')
  }
  let nImg = new Image()
  nImg.setAttribute('crossOrigin', 'Anonymous')
  if (!imageUrl.match(/^https/)) {
    imageUrl = imageUrl.replace(/^http/g, 'https')
  }
  nImg.src = imageUrl + `?tamp=${Date.now()}`
  const str = await new Promise(resolve => {
    nImg.onload = () => {
      imgDraw(nImg, nImg.width, nImg.height, resolve, dataArr)
    }
    nImg.onerror = () => {
      console.log('图片加载失败')
    }
  })
  return str
}
const imgDraw = (img, width, height, resolve, dataArr) => {
  var f_img = new fabric.Image(img)
  let canvasimg = document.createElement('canvas')
  canvasimg.setAttribute('id', 'canvas')
  let canvas = new fabric.Canvas('canvas', {
    width,
    height,
    fireRightClick: true, //启用右键
    stopContextMenu: true, //禁用右键菜单
    selectionColor: 'transparent', // 选框填充色：透明
    selectionLineWidth: 0 //边框宽度0
  })
  canvas.setBackgroundImage(f_img, canvas.renderAll.bind(canvas))
  //  添加文字
  addText(canvas, dataArr, resolve)
}
const addText = (canvas, dataArr, resolve) => {
  // 创建一个矩形对象
  let groups = []
  let Promises = []
  dataArr.forEach(item => {
    let obj = null
    switch (item.code) {
      case 'T':
        // 正确
        Promises.push(
          new Promise(resolve => {
            fabric.Image.fromURL(require('./img/right.svg'), img => {
              img.set({
                left: item.left,
                top: item.top,
                crossOrigin: 'Anonymous'
                // 使用的图片跨域时，配置此参数，有时会失效
              })
              groups.push(img)
              resolve()
            })
          })
        )
        break

      case 'F':
        // 错误
        Promises.push(
          new Promise(resolve => {
            fabric.Image.fromURL(require('./img/wrong.svg'), img => {
              img.set({
                left: item.left,
                top: item.top,
                crossOrigin: 'Anonymous'
                // 使用的图片跨域时，配置此参数，有时会失效
              })
              groups.push(img)
              resolve()
            })
          })
        )
        break
      case 'C':
        // 半对
        Promises.push(
          new Promise(resolve => {
            fabric.Image.fromURL(require('./img/rightBan.svg'), img => {
              img.set({
                left: item.left,
                top: item.top,
                crossOrigin: 'Anonymous'
                // 使用的图片跨域时，配置此参数，有时会失效
              })
              groups.push(img)
              resolve()
            })
          })
        )
        break
      case 'Tx':
        //  字
        obj = new fabric.Text(item.text, {
          top: item.top,
          left: item.left,
          fontFamily: 'PingFang SC',
          fontSize: item.fontSize || 30,
          fontWeight: 'bold',
          fill: 'red'
        })
        break

      default:
        break
    }

    obj && groups.push(obj)
  })

  // 创建组
  Promise.all(Promises).then(() => {
    const group = new fabric.Group(groups, {
      objectCaching: false // 不缓存！！！
    })
    canvas.add(group)
    let url = canvas.toDataURL()
    resolve({ url })
  })
}

export const getUser = (params = { latest: false }) => {
  const userInfo = getStore('userInfo') || {}
  const key = Object.keys(userInfo)
  if (params.latest || !key.length) {
    return axios({
      host: 'centerApi',
      url: 'userAuth'
    }).then(res => {
      if (res.status) setStore('userInfo', res.data)
      return res
    })
  } else {
    return new Promise(res => {
      res({
        data: { ...userInfo },
        status: true
      })
    })
  }
}
//检查学校
export const schoolIdsCheck = async schoolIds => {
  const data = await getUser()
  return schoolIds.some(item => item === data.schoolId)
}
export const isUnion = () => {
  //获取路由path  判断是否是联考
  const urlStr = window.location.href.replace(/\?.*/g, '')
  const urlArr = urlStr.split('/').filter(item => item)
  const lastPath = urlArr.pop() || ''
  const examTypePath = ['totalReportunion', 'singleReportunion'] //需要切换联考的路由最后一个path
  let apiStr = ''
  if (examTypePath.includes(lastPath)) {
    apiStr = 'Union'
  } else {
    const query = window.location.search
    const removeMark = query.substr(1)
    const createArray = removeMark.split('&')
    let active = createArray.filter(item => item.includes('examIsActive'))
    let activeVum = active.length ? active[0].split('=')[1] : 0
    apiStr = activeVum == 2 ? 'SchoolUnion' : ''
  }
  // examTypePath.includes(lastPath) ? true : false
  return apiStr
}
